export interface DateRangePickerValue {
  dateFrom: string;
  dateTo: string;
  preset?: string | undefined;
}

export enum DateRangePickerPresetKey {
  Today = 'TODAY',
  Yesterday = 'YESTERDAY',
  ThisWeek = 'THIS_WEEK',
  Last7Days = 'LAST_7_DAYS',
  ThisMonth = 'THIS_MONTH',
  LastMonth = 'LAST_MONTH',
  Last30Days = 'LAST_30_DAYS',
  Last3Months = 'LAST_3_MONTHS',
  Last6Months = 'LAST_6_MONTHS',
  Last12Months = 'LAST_12_MONTHS',
  ThisYear = 'THIS_YEAR',
  LastYear = 'LAST_YEAR',
}

export interface DateRangePickerPreset {
  key: DateRangePickerPresetKey | (string & {});
  label: string;
  getValue: () => Pick<DateRangePickerValue, 'dateFrom' | 'dateTo'>;
}

export interface DateRangeDraft {
  from: Date | undefined;
  to?: Date | undefined;
}

export enum CalendarView {
  Days = 'days',
  Months = 'months',
  Years = 'years',
}
